<template>
    <ul class="ui-autocomplete ui-menu ui-widget ui-widget-content ui-corner-all" id="autoCompleteSearchResults" tabindex="0">
      <div class="list-wrapper" v-bind:class="{ 'has-history': hasHistory}">
        <li><a href="/catalog/magic_the_gathering/search" class="advanced-search-link">Advanced Search <i class="fa-solid fa-arrow-right"></i></a></li>

        <li><span class="recent-searches text-secondary text-left" v-if="searchResults.length < 1 && searchHistory.length > 0">Recent Searches</span></li>
        <search-result-item v-if="searchResults.length < 1" :key="buildKey(result)" :index="index" :selectedItem="selectedItem" :title="result" :searchValue=searchValue v-for="(result,index) in searchHistory.slice().reverse()" v-on:searchOnThis="searchOnThis" @active-title="setActiveTitle" />

        <li class="clear-search-history"><a @click="clearSearchHistory" v-if="searchResults.length < 1 && searchHistory.length > 0">Clear Search History</a></li>

        <search-result-item :key="buildKey(result)" :index="index" :selectedItem="selectedItem" :title="result" :searchValue=searchValue v-for="(result,index) in searchResults" v-on:searchOnThis="searchOnThis" @active-title="setActiveTitle" />
      </div>
    </ul>
</template>

<script>
  import SearchResultItem from './SearchResultItem.vue';
  export default {
    components: { SearchResultItem },
    computed: {
      hasHistory() {
        return this. searchHistory.length > 0;
      }
    },
    props: {
      searchValue: {
        type: String,
        default: () => ('')
      },
      searchHistory: {
        type: Array,
        default: () => ([]),
      },
      searchResults: {
        type: Array,
        default: () => ([]),
      },
      selectedItem:{
        type: Number,
        default: () => (null)
      }
    },
    methods: {
      buildKey(title) {
        return (Math.random() + '-' + (title.replace(/[\W_]+/g, '')));
      },
      clearSearchHistory(){
        this.$emit('clearSearchHistory');
      },
      searchOnThis(title) {
        this.$emit('searchOnThis', title);
      },
      setActiveTitle(title){
        this.$emit('active-title',title);
      },

    }

  };

</script>

<style>
#autoCompleteSearchResults {
  background-color: transparent;
  border: none;
  border-bottom-left-radius: .25rem;
  border-bottom-right-radius: .25rem;
  display: block;
  font-size: 1rem;
  height: auto;
  list-style-type: none;
  margin: 0;
  margin-left: -1rem;
  overflow: hidden;
  padding: 0;
  position: absolute;
  top: 2.375rem;
  width: 15rem;
  box-shadow: 0 .25rem 1rem 0 rgba(0, 0, 0, 0.6);
}

#autoCompleteSearchResults .list-wrapper {
  background-color: white;
  margin-top: 2rem;
  max-height: 26rem;
  overflow-y: auto;
}

#autoCompleteSearchResults .list-wrapper.has-history {
  padding-bottom: 2rem;
}
#autoCompleteSearchResults .advanced-search-link {
  border-bottom: 1px solid #e2e5e9; /* light-grey */
  color: #1666b2; /* primary blue */
  font-weight: 500;
  padding: .5rem 1rem;
  position: absolute;
  background-color: white;
  width: 100%;
}
#autoCompleteSearchResults .clear-search-history {
  background-color: #fff;
  bottom: 0rem;
  position: absolute;
  width: 100%;
}
#autoCompleteSearchResults .clear-search-history > a {
  border-top: 1px solid #e2e5e9;
  color: #1666b2; /* primary blue */
  font-weight: 400;
}

#autoCompleteSearchResults li {
  cursor: pointer;
  display: block;
}
#autoCompleteSearchResults li:first-child {
  height: 2rem;
  position: absolute;
  margin-top: -2rem;
  width: 100%;
}
#autoCompleteSearchResults li.autocompleteItem.active span,
#autoCompleteSearchResults li a:focus,
#autoCompleteSearchResults li a:hover,
#autoCompleteSearchResults li span:focus,
#autoCompleteSearchResults li span:hover {
  background-color: #ceeeff;
  text-decoration: none;
  outline: none;
}
#autoCompleteSearchResults li span.recent-searches:hover {
  background-color: transparent;
  cursor: default;
}
#autoCompleteSearchResults li.autocompleteItem b {
  font-weight: 400 !important;
}
#autoCompleteSearchResults li.autocompleteItem b.result-highlight {
  font-weight: bold !important;
}

#autoCompleteSearchResults li a,
#autoCompleteSearchResults li span {
  cursor: pointer;
  display: block;
  line-height: 1rem;
  padding: .5rem 1rem;
}


@media only screen and (min-width: 584px) {
  #autoCompleteSearchResults {
    width: 19rem;
  }
}

@media only screen and (min-width: 776px) {
  #autoCompleteSearchResults {
    top: 2.75rem;
    width: 14rem;
  }
}

@media only screen and (min-width: 1016px) {
  #autoCompleteSearchResults {
    width: 18rem;
  }
}

@media only screen and (min-width: 1200px) {
  #autoCompleteSearchResults {
    width: 19rem;
  }
}
</style>